<template>
  <div class="hero-section">
    <div class="hero-section-wrap">
      <template v-for="item in contentList">
        <div class="hero-section-item" v-if="item.status === MODULE_STATUS.NORMAL" :key="item.id" @click="handleJump(item)">
          <div class="hero-section-img">
            <img class="hero-section-corner" :src="item.cornerUrl" alt="" />
            <img class="hero-section-icon" :src="item.iconUrl" alt="" />
          </div>
          <span class="hero-section-text">{{ item.name }}</span>
        </div>
      </template>
    </div>
    <van-popup v-model="show">{{ showText }}</van-popup>
  </div>
</template>

<script>
import { KINGKONG_LINK_TYPE, KINGKONG_PAGE_CONFIG_IMG_MAP, MODULE_STATUS } from './constant'
import { Dialog, Popup } from 'vant'

export default {
  name: 'HeroSection',
  components: {
    [Popup.name]: Popup,
  },
  props: {
    content: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      MODULE_STATUS,
      show: false,
      showText: '',
    }
  },
  computed: {
    contentList() {
      return this.$props.content.filter((v) => v.status === MODULE_STATUS.NORMAL).slice(0, 10)
    },
  },
  methods: {
    /** 处理跳转 */
    handleJump(item) {
      switch (item.skipType) {
        case KINGKONG_LINK_TYPE.PAGE:
          const url = KINGKONG_PAGE_CONFIG_IMG_MAP.get(item.pageType)
          this.$router.push(`/preview/page?url=${url}`)
          break
        case KINGKONG_LINK_TYPE.EXTERNAL_LINK:
          this.showText = item.skipLink
          this.show = true
          break
        case KINGKONG_LINK_TYPE.MINIPROGRAM:
          Dialog.confirm({
            message: '即将打开“云会甄选小程序”',
            confirmButtonText: '允许',
          })
          break
        case KINGKONG_LINK_TYPE.CUSTOM:
          this.showText = item.skipLink
          this.show = true
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.hero-section {
  width: 100%;
  background-color: #fff;
  border-radius: 0 0 40px 40px;
  /deep/ .van-popup {
    background: transparent;
    color: #fff;
  }
}

.hero-section-wrap {
  display: flex;
  padding: 18px 32px 32px;
  overflow-x: auto;

  .hero-section-item {
    margin-right: 60px;
    &:last-child {
      margin-right: 0;
    }

    .hero-section-img {
      position: relative;
      display: flex;
      justify-content: center;
      .hero-section-corner {
        width: auto;
        height: 28px;
        display: block;
        position: absolute;
        left: 54px;
        top: -6px;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
      .hero-section-icon {
        width: 80px;
        height: 80px;
      }
    }
    .hero-section-text {
      margin-top: 8px;
      font-size: 26px;
      color: #222222;
      line-height: 36px;
    }
  }
}
</style>
